export default __webpack_public_path__ + "static/btc-6412e7e9ea0edbb4e5c034f477b7cefb.svg";